module.exports = __webpack_public_path__ + "img/18.5b69d7cd.png";